import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import viewImage from "../../../assets/images/icons/view.svg";
import TeamImg from '../../../assets/images/login-bg.jpg';
import editImage from "../../../assets/images/icons/edit.svg";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoints } from "../../../utils/endpoints";
import { toast } from "react-toastify";
import TablePagination from "../../../commons/Pagination/TablePagination";

function RestaurantPayoutList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [cms, setCms] = useState({ type: "publish" });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Restaurant Payout List</h3>
            </div>
            <div class="mt-3">
              <Link to='/menu-and-restaurant-management' class="btn btn-default rounded-lg">Back</Link>
            </div>
            <div className="mb-4 px-0 py-2 mt-3">
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th align="left">Order ID</th>
                        <th>Order date</th>
                        <th>Price</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>                      
                        <tr>
                            <td className="text-left">#2313343</td>
                            <td className="text-center">01-May-2025</td>
                            <td>£50.2</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Link to="/view-order" className="mx-2">
                                        <img src={viewImage} alt="View" />
                                    </Link>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">#2313343</td>
                            <td className="text-center">01-May-2025</td>
                            <td>£50.2</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Link to="/view-order" className="mx-2">
                                        <img src={viewImage} alt="View" />
                                    </Link>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">#2313343</td>
                            <td className="text-center">01-May-2025</td>
                            <td>£50.2</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Link to="/view-order" className="mx-2">
                                        <img src={viewImage} alt="View" />
                                    </Link>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">#2313343</td>
                            <td className="text-center">01-May-2025</td>
                            <td>£50.2</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Link to="/view-order" className="mx-2">
                                        <img src={viewImage} alt="View" />
                                    </Link>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td className="text-left">#2313343</td>
                            <td className="text-center">01-May-2025</td>
                            <td>£50.2</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-center">
                                    <Link to="/view-order" className="mx-2">
                                        <img src={viewImage} alt="View" />
                                    </Link>
                                </div>
                            </td>
                        </tr>
                        {/* <tr>
                          <td colSpan="6" className="text-center py-4">
                            No Data Found
                          </td>
                        </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RestaurantPayoutList;
